import { Button, Spinner } from "react-bootstrap";
import styled from "styled-components";

import { Field } from "./types";
import { ReactNode, useEffect, useState } from "react";
import { useAATheme } from "../AAThemeContext";

const FilterLabel = styled.span`
  font-weight: bold;
`;

const FilterValue = styled.span``;

const FilterChip = ({
  field,
  value,
  showValue = true,
  onClick,
  required = false,
}: {
  field: Field;
  value?: string;
  showValue?: boolean;
  onClick: () => void;
  required?: boolean;
}) => {
  const [formattedValue, setFormattedValue] = useState<ReactNode>(null);
  const { isDarkMode } = useAATheme();

  useEffect(() => {
    const fetchFormattedValue = async () => {
      if (!field.formatValue) {
        setFormattedValue(value);
        return;
      }
      setFormattedValue(await field.formatValue(value));
    };
    fetchFormattedValue();
  }, [field.formatValue, value]);

  if (required && showValue) {
    return (
      <span className="pe-2">
        <FilterLabel>{field.label}: </FilterLabel>
        <FilterValue className="font-weight-light">
          {formattedValue}
        </FilterValue>
      </span>
    );
  }

  return (
    <Button
      data-testid={`filter-chip-${field.name}`}
      onClick={onClick}
      variant={isDarkMode ? "dark" : "light"}
    >
      <FilterLabel>{showValue ? `${field.label}: ` : field.label}</FilterLabel>
      {showValue && (
        <>
          {formattedValue ? (
            <FilterValue className="font-weight-light">
              {field.showMonoValue ? (
                <code>{formattedValue}</code>
              ) : (
                formattedValue
              )}
            </FilterValue>
          ) : (
            <Spinner size="sm" />
          )}
        </>
      )}
      <i className="bi-x" />
    </Button>
  );
};

export default FilterChip;
